const SERVICE = 'alert-service'

const getAlerts = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/user', params)

module.exports = {
  getAlerts,
}
  